import { candidateRouteKeys } from 'candidate-url-registry';
import { registerCandidateRouteAdapter } from 'candidate-app/routeAdapters';

import { externalSchedulingSession } from './session';

const matches = () => Boolean(externalSchedulingSession());
const loadScheduling = () => import('./ExternalAgentSchedulingPage');
for (const key of candidateRouteKeys) {
  if (
    key.includes('SCHEDULE') &&
    key !== 'RESCHEDULE' &&
    key !== 'RESCHEDULE_CALENDAR'
  ) {
    registerCandidateRouteAdapter(key, { matches, load: loadScheduling });
  }
}
registerCandidateRouteAdapter('RESCHEDULE', {
  matches,
  load: () => import('./ExternalRescheduleReasonPage'),
});
registerCandidateRouteAdapter('RESCHEDULE_CALENDAR', {
  matches,
  load: () => import('./ExternalRescheduleInterviewPage'),
});
